import React from 'react'

const NuestrosSistemas = () => {
  return (
    <section>
      <div className='tw-mt-8 tw-mt-8@lg tw-mb-8 tw-mb-8@lg'>
        <h2 className='font-family-secondary c-gray--4 fw-7 tw-m-0 tw-f-20 tw-f-24@lg tw-mb-4 tw-mb-4@lg'>
          Nuestros Sistemas de Videovigilancia
        </h2>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Prima AFP cuenta con un sistema de videovigilancia y se encuentra autorizado, bajo las 
          normas vigentes (Ley No. 29733, su reglamento o aquellas que la modifican o sustituyan), 
          para tratar los datos personales que hayan sido captados mediante dichos sistemas.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          Su finalidad es garantizar y salvaguardar la seguridad del Banco de Datos, sus usuarios 
          y/o para realizar control laboral y, por ello, Prima AFP podrá tratar los datos personales 
          que hayan sido captados mediante dicho sistema. Almacenaremos la información recopilada 
          en el siguiente banco de datos:
        </p>
        <div className='c-gray--4 left tw-mb-4 tw-mb-4@lg'>
          <ul className={`w-100 bulletList-0 font-family-primary tw-f-16 tw-f-16@lg tw-mt-2`}>
            <li className='tw-mb-2'>
              <strong>Código de Registro:</strong> RNPDP-PJP Nº 9392.
            </li>
            <li className='tw-mb-2'>
              <strong>Titular del Banco de Datos:</strong> Prima AFP.
            </li>
            <li className='tw-mb-2'>
              <strong>Denominación:</strong> Videovigilancia.
            </li>
            <li>
              <strong>Plazo de Conservación:</strong> La información será almacenada hasta por 
              30 días hábiles, de acuerdo con la regulación vigente.
            </li>
          </ul>
        </div>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          <strong>
            ¿Los datos personales que captemos mediante sistemas de videovigilancia 
            pueden ser transferidos a terceros?
          </strong>
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-4@lg'>
          No, no serán transferidos a terceros, salvo que sea requerido por una autoridad 
          competente y/o exista una obligación legal.
        </p>
        <p className='font-family-primary c-gray--4 tw-f-16 tw-f-16@lg tw-mb-4 tw-mb-8@lg'>
          Puedes acceder a tus datos, conocer sobre su tratamiento, oponerse a su tratamiento 
          o solicitar sean suprimidos, dirigiéndote a Prima AFP virtual y/o presencial en 
          cualquiera de sus oficinas a nivel nacional en el horario establecido para la 
          atención al público, por teléfono o a través del Chat ubicado en nuestra página web{' '}
          <a
            className='c-orange-0 b underline'
            target='_blank'
            rel='noopener noreferrer'
            href='https://www.prima.com.pe'
          >
            www.prima.com.pe.
          </a>{' '}Para ejercer los derechos antes mencionados, deberás presentar 
          tu documento de identidad (DNI/CE/Pasaporte) y la Solicitud con los datos necesarios, 
          la fecha, rango de horas, lugar y cualquier otra información que permita facilitar la 
          ubicación de la imagen requerida incluyendo una imagen actualizada de ti mismo que 
          permita verificar tu presencia en el registro. Prima AFP ha establecido las medidas 
          de seguridad exigidas por las normas aplicables para proteger sus datos personales.
        </p>
      </div>
    </section>
  )
}

export default NuestrosSistemas
